import React, { FC, useEffect, useState } from "react";
import Button from "../../../components/UI/button/GgButton";
import { dateFormat } from "../../../utils";
import { DocIcon } from "../../../assets/icons";
import { $public } from "../../../http";
import { Context } from "../../..";
import Spinner from "../../../components/UI/spinner/Spinner";

export interface IReportItem {
  address: string;
  client: any;
  created_at: Date;
  documents: string;
  status: "default" | "awaiting" | "loaded" | "rejected";
  updated_at: Date;
  _id: string;
}

export interface IReportItemProps {
  data: IReportItem;
  handleReport?: any;
  setReports?: (data: any) => void;
  deletePropertyReport?: any;
  userId?:string
  actionData?: any
}

const ReportItem: FC<IReportItemProps> = ({ data, handleReport, userId, actionData }) => {
  const { site, users } = React.useContext(Context);
  const [loading, setLoading] = useState<boolean>(true);

  const updateUserReport = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      let formData = new FormData();
      formData.append("report_id", data._id);
      formData.append("file", e.target.files[0]);
      await site.updateReport(formData);
      const results = await handleReport.loadList(formData);
      if (results) {
        handleReport.setSelectedUser(results[0]);
      }
    }
  };

  const downloadPropertyReport = async () => {
    let link = document.createElement("a");
    link.target = "_blank";
    link.href = $public(`client/account/documents/download${data?.documents}`);
    link.click();
    link.remove();
  };

  const deletePropertyReport = async (id:string) => {
    if (window.confirm("Are you sure you want to delete user property reports !")) {
      setLoading(false)
      await site.deleteReport(id)
      await users.loadOne(userId)
      setLoading(true)
    }
  }

  async function loadNewUser(){
    const response = await site.loadReports()
    console.log(response);
  }
  

  return (
    <div className="card-item">
      <div className="card-info">
        <div className="card-title status">
          <span className="piece">{data.address}</span>
          <span className="piece">
            {data.status === "loaded" ? "Replied" : data.status}
          </span>
        </div>
        <div className="content">
          <span className="piece">
            Created: {dateFormat(data.created_at)} /{" "}
          </span>
          <span className="piece">Updated: {dateFormat(data.updated_at)}</span>
          {/* <span className="piece">Applicants: {"Mitchael"}</span> */}
        </div>
      </div>
      <div className="controls" style={{display:'flex', justifyContent:"space-between", width:"100%"}}>
        {actionData?.delete ? (
          loading ? (
            <Button label="Delete" onPress={() => deletePropertyReport(data._id)} />
        ) : (
          <Spinner />
        )
        ) : ""} 
        {actionData?.edit ? (
          data?.status !== "loaded" && (
            <label className="upload">
              <input type="file" onChange={updateUserReport} />
              <span className="file-button-label">Reply</span>
            </label>
          )
        ) : ""}
        {data?.status === "loaded" && (
          <abbr title="Download Report">
            <Button
              icon={{ leftIcon: <DocIcon /> }}
              stylesType="round"
              className="download-btn"
              onPress={downloadPropertyReport}
            />
          </abbr>
        )}
      </div>
    </div>
  );
};

export default ReportItem;
